
export default function Header() {
  return (
    <header className="bg-gray-900/80 backdrop-blur-sm border-b border-gray-800 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
              ChillPan
            </h1>
            <p className="text-sm text-gray-400 mt-1">
              플레이까지 걸리는 시간으로 찾는 HTML5 게임
            </p>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-4xl">🎮</span>
          </div>
        </div>
      </div>
    </header>
  );
}
